import { render, staticRenderFns } from "./InAppProductModal.vue?vue&type=template&id=38910726&scoped=true"
import script from "./InAppProductModal.vue?vue&type=script&lang=js"
export * from "./InAppProductModal.vue?vue&type=script&lang=js"
import style0 from "./InAppProductModal.vue?vue&type=style&index=0&id=38910726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38910726",
  null
  
)

export default component.exports